export default "__VITE_ASSET__65871d2d__"